export const makeActionList = () => {
	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Add',
				id: 'add',
				isEnabled: () => {
					return true;
				}
			},
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return true;
				}
			}
		]
	};
};

export default {
	makeActionList
};
